/** True in the Tauri desktop build (vite --mode desktop). The browser build keeps cookie sessions. */
export function isDesktop(): boolean {
  const raw: unknown = import.meta.env?.["VITE_CLIENT"];
  return raw === "desktop";
}
